import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiMutationKeys, AiQueryKeys } from "#lib/AiQueryKeys.ts";
import type { DeleteConversationCommand } from "#types/types.ts";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeleteConversationMutation = (onSuccess: () => void) => {
    const queryClient = useQueryClient();
    const client = useAiApiClient();

    return useMutation(
        {
            mutationKey: AiMutationKeys.DeleteConversation(),
            mutationFn: (payload: DeleteConversationCommand) => client.deleteConversation(payload),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: AiQueryKeys.GetConversations() });
                onSuccess();
            }
        }
    );
};
